import Spinner from '../Spinner';
import './index.scss';

export default () => (
  <div className="full-page-spinner">
    <Spinner />
  </div>
);
